<style lang="scss" scoped>
</style>
<template>
  <el-card shadow="never" class="l-main-card">
    <!--左边角色选择-->
    <div class="l-container-sider">
      <l-role-list ref="roleList" @on-after-check="aftercheckRole" @on-before-check="beforeCheckRole" :id="of_type"></l-role-list>
    </div>

    <!--右边菜单列表-->
    <div class="l-container-content">
      <div class="l-menu-box" v-loading="spinning">
        <div class="l-container-title">
          <i class="el-icon-menu" /><b>功能权限</b>
          <l-auth-text-button auth="permission_add_btn" type="primary" style="float:right;font-size:14px" @click="showAdd('')">
            <i class="el-icon-plus" style="font-size:14px;" />添加
          </l-auth-text-button>
        </div>
        <div class="l-menu-list-main">
          <ul class="l-checkbox-group-list">
            <li v-for="item in list" :key="item.id">

              <!--权限标题-->
              <el-checkbox :indeterminate="isIndeterminate(item)" :value="isAllChecked(item)" @change="(is_check)=>handleCheckAll(is_check,item)" class="l-checkbox-group-title">
                <span>{{item.name}}</span>
              </el-checkbox>
              <!--操作-->
              <span style="margin-left:15px;font-weight:200;font-size:14px">
                <l-auth-text-button auth="permission_add_btn" type="primary" @click.stop="showAdd(item.id)">
                  添加子权限
                </l-auth-text-button>
                <l-auth-text-button auth="permission_edit_btn" type="primary" @click.stop="showEdit(item.id)" style="margin-left:10px">
                  <i class="el-icon-edit"></i>
                </l-auth-text-button>
                <l-auth-text-button auth="permission_del_btn" type="danger" @click.stop="del(item.id)" style="margin-left:10px">
                  <i class="el-icon-delete"></i>
                </l-auth-text-button>
              </span>
              <div style="margin: 10px 0;"></div>

              <!--子权限列表-->
              <el-checkbox-group v-model="rolePermission">
                <el-row :gutter="10">
                  <el-col v-for="permission in item.children" :key="permission.id" :lg="12" :md="24" :sm="24" :xl="6" style="margin-top:15px">

                    <el-checkbox :label="permission.id">
                      <span>{{permission.name}}</span>

                      <!--操作-->
                      <span style="margin-left:15px">
                        <l-auth-text-button auth="permission_edit_btn" type="primary" @click.native.prevent="showEdit(permission.id)">
                          <i class="el-icon-edit"></i>
                        </l-auth-text-button>
                        <l-auth-text-button auth="permission_del_btn" type="danger" @click.native.prevent="del(permission.id)" style="margin-left:5px">
                          <i class="el-icon-delete"></i>
                        </l-auth-text-button>
                      </span>
                    </el-checkbox>
                  </el-col>
                </el-row>
              </el-checkbox-group>

            </li>
          </ul>
        </div>
        <div class="l-menu-footer">
          <el-button type="primary" @click="savePermission" :loading="submitting">保存</el-button>
        </div>
      </div>
    </div>

    <!--添加-->
    <l-dialog :visible.sync="show_add" title="添加权限" width="1000px">
      <l-permission-edit @on-success="onAddSucess" :visible.sync="show_add" :pid="add_pid"></l-permission-edit>
    </l-dialog>

    <!--编辑-->
    <l-dialog :visible.sync="show_edit" title="编辑权限" width="1000px">
      <l-permission-edit @on-success="onEditSucess" :visible.sync="show_edit" :id="edit_id"></l-permission-edit>
    </l-dialog>
  </el-card>
</template>

<script>
  import RoleList from '../role/RoleList'
  import PermissionEdit from './Edit';
  export default {
    name: 'pemission-index',
    components: {
      [RoleList.name]: RoleList,
      [PermissionEdit.name]: PermissionEdit,
    },

    data() {
      return {
        of_type:1,  //获取用户列表 类型  1 是管理后台  2 为小程序
        spinning: false,
        role_id: '',
        re_list: [],
        list: [],
        rolePermission: [],
        reRolePermission: [],

        show_add: false,
        add_pid: '',

        show_edit: false,
        edit_id: 0,

        submitting: false,
      }
    },

    methods: {
      //选择角色前的回调
      beforeCheckRole() {
        this.spinning = true;
      },


      //选择角色后的回调
      aftercheckRole(id) {
        console.log("是我是我")
        console.log(id)
        this.$_invoke(`rolePermission_getPermissionByRole`, { id,pid:1 }).then((ret) => {
          this.role_id = id;
          this.spinning = false;
          const tree = ret.tree.map(item => {
            let is_all_checked = true;
            let indeterminate = false;
            item.children.forEach(child => {
              const index = ret.role_permission.findIndex(permission => {
                return permission == child.id;
              });
              if (index === -1) {
                is_all_checked = false;
              } else {
                indeterminate = true;
              }
            });
            if (is_all_checked) {
              item.is_all_checked = true;
              item.indeterminate = false;
            } else {
              item.is_all_checked = false;
              if (indeterminate) {
                item.indeterminate = true;
              }
            }
            return item;
          });
          this.re_list = tree.concat([]);
          this.list = tree;
          this.rolePermission = ret.role_permission.concat([]);
          this.reRolePermission = ret.role_permission;
        });
      },

      //是否半选择状态
      isIndeterminate(item) {
        let indeterminate = false;
        let is_all_checked = true;
        item.children.forEach(child => {
          const index = this.rolePermission.findIndex(permission => {
            return permission == child.id;
          });
          if (index === -1) {
            is_all_checked = false;
          } else {
            indeterminate = true;
          }
        });
        if (is_all_checked) {
          indeterminate = false;
        } else {
          if (indeterminate) {
            indeterminate = true;
          }
        }

        return indeterminate;
      },

      //是否全选
      isAllChecked(item) {
        let is_all_checked = true;
        item.children.forEach(child => {
          const index = this.rolePermission.findIndex(permission => {
            return permission == child.id;
          });
          if (index === -1) {
            is_all_checked = false;
          }
        });

        return is_all_checked;
      },

      //全选
      handleCheckAll(is_check, item) {
        if (is_check) {//选中状态将其下所有权限添加到已选权限中
          item.children.forEach(child => {
            const index = this.rolePermission.findIndex(permission => {
              return child.id == permission;
            });
            if (index === -1) {
              this.rolePermission.push(child.id);
            }
          })
        } else {//非选中状态，将其下所有权限移除
          item.children.forEach(child => {
            const index = this.rolePermission.findIndex(permission => {
              return child.id == permission;
            });
            if (index !== -1) {
              this.rolePermission.splice(index, 1);
            }
          })
        }
      },


      //保存权限
      savePermission() {
        this.spinning = true;
        const { role_id, rolePermission, reRolePermission } = this;
        this.$_invoke(`rolePermission_save`, {
          role_id,
          role_permission: rolePermission,
          re_role_permission: reRolePermission
        }).then(() => {
          this.$_msg.success('保存成功！');
        }).finally(() => {
          this.spinning = false;
        });
      },

      //显示添加权限弹窗
      showAdd(pid) {
        this.add_pid = pid;
        this.$nextTick(() => {
          this.show_add = true;
        })
      },

      //添加成功回调
      onAddSucess() {
        this.show_add = false;
        this.$refs.roleList.checkRole(this.role_id);
      },

      //显示修改界面
      showEdit(id) {
        this.edit_id = id;
        this.$nextTick(() => {
          this.show_edit = true;
        });
      },

      //编辑成功回调
      onEditSucess() {
        this.show_edit = false;
        this.$refs.roleList.checkRole(this.role_id);
      },

      //删除权限
      del(id) {
        this.$confirm('确定删除该条记录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.$_invoke(`permission_delete`, { id }).then(() => {
            this.$_msg.success('删除成功');
            this.$refs.roleList.checkRole(this.role_id);
          });
        }).catch(() => {
        });
      },

    }
  }
</script>